import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
const CONCERNS = ['Contracts', 'Employment & HR', 'Privacy & website terms', 'Compliance', 'Corporate structure', 'Not sure yet'];
export function BusinessReadinessPage() {
  const navigate = useNavigate();
  const {
    business,
    updateBusiness
  } = useAuth();
  const [formData, setFormData] = useState({
    hasLegalSupport: business?.hasLegalSupport || '',
    concerns: business?.concerns || [],
    businessAge: business?.businessAge || ''
  });
  const toggleConcern = (concern: string) => {
    setFormData(prev => {
      const isSelected = prev.concerns.includes(concern);
      if (isSelected) {
        return {
          ...prev,
          concerns: prev.concerns.filter(c => c !== concern)
        };
      } else {
        return {
          ...prev,
          concerns: [...prev.concerns, concern]
        };
      }
    });
  };
  const handleNext = () => {
    updateBusiness(formData);
    navigate('/onboarding/summary');
  };
  const handleBack = () => {
    navigate('/onboarding/business-details');
  };
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1284">
      <div className="sm:mx-auto sm:w-full sm:max-w-xl" data-id="element-1285">
        <div className="mb-8" data-id="element-1286">
          <div className="flex justify-between items-center mb-2" data-id="element-1287">
            <span className="text-sm font-semibold text-primary" data-id="element-1288">
              Business Readiness
            </span>
            <span className="text-sm font-medium text-secondary" data-id="element-1289">Step 5</span>
          </div>
          <div className="w-full bg-borderColor rounded-full h-2" data-id="element-1290">
            <div className="bg-violetBlue h-2 rounded-full transition-all duration-300" style={{
            width: '100%'
          }} data-id="element-1291"></div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white py-8 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor" data-id="element-1292">
          <div className="space-y-8" data-id="element-1293">
            <div data-id="element-1294">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1295">
                Do you already have a lawyer or legal support?
              </label>
              <div className="flex gap-4" data-id="element-1296">
                {['Yes', 'No', 'Sometimes'].map(option => <button key={option} onClick={() => setFormData({
                ...formData,
                hasLegalSupport: option
              })} className={`flex-1 py-3 px-4 rounded-lg border ${formData.hasLegalSupport === option ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1297">
                    {option}
                  </button>)}
              </div>
            </div>

            <div data-id="element-1298">
              <label className="block text-sm font-medium text-primary mb-3" data-id="element-1299">
                What are you mainly concerned about?
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-1300">
                {CONCERNS.map(concern => {
                const isSelected = formData.concerns.includes(concern);
                return <button key={concern} onClick={() => toggleConcern(concern)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors border ${isSelected ? 'bg-violetBlue text-white border-violetBlue' : 'bg-white text-secondary border-borderColor hover:bg-aliceBlue hover:text-primary'}`} data-id="element-1301">
                      {concern}
                    </button>;
              })}
              </div>
            </div>

            <div data-id="element-1302">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1303">
                Is this a new business or an existing business?{' '}
                <span className="text-secondary font-normal" data-id="element-1304">(Optional)</span>
              </label>
              <div className="flex gap-4" data-id="element-1305">
                {[{
                id: 'new',
                label: 'New business'
              }, {
                id: 'existing',
                label: 'Existing business'
              }].map(option => <button key={option.id} onClick={() => setFormData({
                ...formData,
                businessAge: option.id
              })} className={`flex-1 py-3 px-4 rounded-lg border ${formData.businessAge === option.id ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1306">
                    {option.label}
                  </button>)}
              </div>
            </div>
          </div>

          <div className="mt-10 flex justify-between gap-4" data-id="element-1307">
            <button onClick={handleBack} className="flex items-center px-6 py-3 border border-borderColor rounded-lg text-sm font-semibold text-primary hover:bg-aliceBlue transition-colors" data-id="element-1308">
              <ChevronLeft className="w-4 h-4 mr-1" data-id="element-1309" /> Back
            </button>
            <button onClick={handleNext} className="flex items-center px-8 py-3 bg-violetBlue text-white rounded-lg text-sm font-semibold hover:opacity-90 transition-opacity" data-id="element-1310">
              Continue <ChevronRight className="w-4 h-4 ml-1" data-id="element-1311" />
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}